import {Injectable} from '@angular/core';

/**
 * Service zum Speichern und Abrufen der Retry-URL für DATEV-Login-Fehler
 *
 * Verwendung:
 * - Vor jedem DATEV-Redirect: `saveRetryUrl(window.location.href)`
 * - Bei Fehler im Login-Component: `getRetryUrl()` für Navigation
 * - Nach erfolgreichem Login: `clearRetryUrl()` für Cleanup
 */
@Injectable({
  providedIn: 'root'
})
export class DatevWizardRetryContextService {

  private readonly STORAGE_KEY = 'datev_wizard_retry_url';

  /**
   * Speichert die aktuelle URL für späteren Retry
   * @param url Die URL, zu der bei einem Fehler zurückgesprungen werden soll
   */
  saveRetryUrl(url: string): void {
    try {
      sessionStorage.setItem(this.STORAGE_KEY, url);
    } catch (error) {
      console.error('Fehler beim Speichern der Retry-URL:', error);
    }
  }

  /**
   * Gibt die gespeicherte Retry-URL zurück
   * @returns Die gespeicherte URL oder null, falls keine vorhanden
   */
  getRetryUrl(): string | null {
    try {
      return sessionStorage.getItem(this.STORAGE_KEY);
    } catch (error) {
      console.error('Fehler beim Abrufen der Retry-URL:', error);
      return null;
    }
  }

  /**
   * Löscht die gespeicherte Retry-URL
   * Sollte nach erfolgreichem Login aufgerufen werden
   */
  clearRetryUrl(): void {
    try {
      sessionStorage.removeItem(this.STORAGE_KEY);
    } catch (error) {
      console.error('Fehler beim Löschen der Retry-URL:', error);
    }
  }
}
